/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportsUserViewDeleteRequest {
    getFixupPrototypeFunction() { return ReportsUserViewDeleteRequest.fixupPrototype; }

    static newInstance(model: Partial<ReportsUserViewDeleteRequest>): ReportsUserViewDeleteRequest {
        let obj = Object.assign(new ReportsUserViewDeleteRequest(), model);
        ReportsUserViewDeleteRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportsUserViewDeleteRequest>): ReportsUserViewDeleteRequest {
        if (!model) return null;
        return ReportsUserViewDeleteRequest.newInstance(<ReportsUserViewDeleteRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportsUserViewDeleteRequest) {
        if (!obj) return;

        models.ReportsUserViewDeleteRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportsUserViewDeleteRequest): boolean {
        Object.setPrototypeOf(obj, ReportsUserViewDeleteRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * unique report id
     */
    report_id: string;

    /**
     * name of the view
     */
    view_name: string;

}
